module.exports = __webpack_public_path__ + "img/info_graphic.6505b75f.svg";